import { ExternalUserResponse } from '../../../../web-api-client';
import { ExternalUser } from '../../models';

export const mapExternalUserFromResponse = (
  response: ExternalUserResponse
): ExternalUser => ({
  id: response.id!,
  email: response.email!,
  firstName: response.firstName!,
  lastName: response.lastName!,
  fullName: `${response.firstName} ${response.lastName}`,
  organization: response.organization!,
  territory: response.territory!,
  isActive: response.isActive ?? false,
  modified: response.modified!,
});
